var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5955f2d-1f1a-4e74-bae4-0df9d2470498",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fbf67c26-ccbb-462c-8075-f264dce526e5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.11,
    width: 95.72,
    height: 95.91,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "40.06 32.35 16.97 9.26 9.37 16.86 32.45 39.95 0.11 39.65 0.21 50.5 32.56 50.8 9.9 73.46 17.65 81.21 40.3 58.55 40.61 90.9 51.46 91 51.16 58.65 74.24 81.74 81.85 74.14 58.76 51.05 91.11 51.35 91 40.5 58.66 40.2 81.32 17.54 73.57 9.79 50.91 32.45 50.61 0.1 39.76 0 40.06 32.35",
    style: {
      fill: "#6fccdc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fbf67c26-ccbb-462c-8075-f264dce526e5)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.34 44.02 62 43.72 84.65 21.06 76.91 13.32 54.25 35.98 53.95 3.63 43.09 3.53 43.4 35.87 20.31 12.79 12.71 20.39 35.79 43.48 3.45 43.17 3.55 54.03 35.9 54.33 13.24 76.99 20.98 84.73 43.64 62.08 43.95 94.42 54.8 94.53 54.49 62.18 77.58 85.27 85.19 77.66 62.1 54.58 94.44 54.88 94.34 44.02",
    style: {
      fill: "none",
      stroke: "#122d51",
      strokeWidth: "1.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue-star.547212a9f027899cf082c095f9506422.svg";
export { ForwardRef as ReactComponent };